const Sortable = require('sortablejs');
const xlsx = require('json-as-xlsx');
import {setNotificationsCallback} from '../signalR/notificationsCallback';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
import { Bar } from 'vue-chartjs'
/**
 * Cannot be imported in components. That's why must be defined as global var
 */
export default function registerGlobals() {
    function watchClass(targetNode, classToWatch) {
        let lastClassState = targetNode.classList.contains(classToWatch);
        const observer = new MutationObserver((mutationsList) => {
            for (let i = 0; i < mutationsList.length; i++) {
                const mutation = mutationsList[i];
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    const currentClassState = mutation.target.classList.contains(classToWatch);
                    if (lastClassState !== currentClassState) {
                        lastClassState = currentClassState;
                        if (!currentClassState) {
                            mutation.target.classList.add('sort-handle');
                        }
                    }
                }
            }
        });
        observer.observe(targetNode, { attributes: true });
    }
    window.watchClass = watchClass;
    window.js2Excel = xlsx;
    window.Sortable = Sortable.Sortable;

    window.signalRNotificationsCallbacks = {}; // set in setNotificationsCallback()
    window.window.globalNotifier = null; // set in EnNotificationPanel https://worxapp.atlassian.net/browse/ENGINE-4143
    window.setNotificationsCallback = setNotificationsCallback;
    window.ChartInstance = {Chart: ChartJS, Bar: Bar};
    // ToDo (PTA): Should not be registered globally
    ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)
}